import { defineComponent, inject, computed, onBeforeMount, onBeforeUnmount, openBlock, createElementBlock, createElementVNode, normalizeClass, createCommentVNode, toDisplayString, createBlock, unref } from "vue";
import CheckedIcon from "../../assets/icons/checked.svg.js";
import { SELECT_KEY } from "./type.js";
const _hoisted_1 = ["src", "alt"];
const _hoisted_2 = { class: "option__text" };
const _hoisted_3 = { class: "option__text-primary" };
const _hoisted_4 = {
  key: 0,
  class: "option__text-secondary"
};
const _hoisted_5 = {
  key: 1,
  class: "option__text-end"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Option",
  props: {
    label: { default: "" },
    value: { default: "" },
    description: {},
    searchText: {},
    icon: {},
    descriptionEnd: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const {
      onOptionSelected,
      onOptionsAdded,
      onOptionRemoved,
      selectedOptions,
      filteredOptions
    } = inject(SELECT_KEY) || {};
    const handleOptionSelected = () => {
      onOptionSelected?.(buildOptionPayload());
    };
    const selected = computed(() => {
      return Array.isArray(selectedOptions?.value) ? selectedOptions.value.some((option) => option.value === props.value) : selectedOptions?.value?.value === props.value;
    });
    const filtered = computed(() => {
      if (!filteredOptions?.value?.length) return false;
      return filteredOptions.value.some((option) => option.value === props.value);
    });
    function buildOptionPayload() {
      return {
        label: props.label,
        value: props.value,
        description: props.description,
        searchText: props.searchText
      };
    }
    onBeforeMount(() => {
      onOptionsAdded?.(buildOptionPayload());
    });
    onBeforeUnmount(() => {
      onOptionRemoved?.(buildOptionPayload());
    });
    return (_ctx, _cache) => {
      return filtered.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "option",
        onClick: handleOptionSelected
      }, [
        createElementVNode("div", {
          class: normalizeClass(["option__content", { selected: selected.value }])
        }, [
          __props.icon ? (openBlock(), createElementBlock("img", {
            key: 0,
            src: __props.icon,
            alt: __props.label,
            class: "option__icon"
          }, null, 8, _hoisted_1)) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", _hoisted_3, toDisplayString(__props.label), 1),
            __props.description && !__props.descriptionEnd ? (openBlock(), createElementBlock("div", _hoisted_4, toDisplayString(__props.description), 1)) : createCommentVNode("", true)
          ]),
          __props.description && __props.descriptionEnd ? (openBlock(), createElementBlock("div", _hoisted_5, toDisplayString(__props.description), 1)) : createCommentVNode("", true),
          selected.value ? (openBlock(), createBlock(unref(CheckedIcon), {
            key: 2,
            class: "option__check"
          })) : createCommentVNode("", true)
        ], 2)
      ])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Option.vue2.js.map
